import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import LogOut from "../../assets/logout.svg";
import Logo from "../../assets/image001.png";
import "./navBar.css";
import AuthContext from "../../store/AuthContext";
import { ThemeContext } from "../../store/ThemeContext";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <div
      className="nav-main"
      style={{
        height: "77px",
        width: "100%",
        padding: "10px 0px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0px 2px 18px 0px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* {authCtx?.user?.organization ? (
        <img src={authCtx?.user?.organization?.imageData} />
      ) : ( */}

      <img
        src={Logo}
        style={{
          maxWidth: "80px",
        }}
      />

      {/* )} */}
      <div
        style={{
          display: "flex",
          marginLeft: "auto",
          justifyContent: "flex-end",
          cursor: "pointer",
          position: "relative",
          paddingRight: "60px",
        }}
        onClick={toggleDropdown}
      >
        {isOpen && (
          <div className="dropdown-content">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => {
                navigate("/reset-password");
              }}
            >
              <ion-icon name="key" style={{ fontSize: 20 }}></ion-icon>Reset
              Password
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => {
                authCtx.logout();
                navigate("/login");
              }}
            >
              <img src={LogOut} alt="Log Out"></img>Log Out
            </div>
          </div>
        )}

        <div
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "100%",
            background: theme?.hightlightColor,
            color: "white",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {authCtx.user?.name?.substring(0, 1)?.toUpperCase()}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            marginLeft: "10px",
            color: "#808080",
            textDecoration: "underline",
          }}
        >
          {authCtx.user?.email}
        </div>
      </div>
      {/* <div className="checkbox">
        <input
          type="checkbox"
          className="checkbox w-[50px] h-14"
          id="check"
          value={authCtx.theme}
          onChange={authCtx.toggleTheme}
        />
      </div> */}
    </div>
  );
};

export default NavBar;
